<div id="container" class="col-md-12S md-md-0 md-10 h-100-margin">
    <section class="container-list h-100-margin">
        <header class="container-list-header">
            <div class="row">
                <div class="col-md-12">
                    <div class="opcion-volver" (click)="goToBack()">
                        <i class="fas fa-angle-left"></i>
                        Volver
                    </div>
                    <div class="d-flex flex-wrap justify-content-between">
                        <div class="d-flex flex-wrap align-items-center city-form-title">
                            <label class="title-component" *ngIf="cityForm">
                                <i class="fas fa-city"></i>
                                Detalle de Ciudad
                            </label>
                            <app-transport-company-context [initialNit]="initialTransportNit"
                                (companyChange)="onTransportCompanyChange($event)">
                            </app-transport-company-context>
                        </div>
                        <div permission-display [module]="permission.administration.module"
                            [functionality]="permission.administration.linkCities">
                            <button mat-raised-button class="primary-secondary button-width-auto" color="primary"
                                (click)="editRteica()" *ngIf="!isMainCity">
                                {{mainCityName.value?'Asociar otra ciudad principal':'Asociar ciudad principal'}}
                            </button>

                        </div>
                    </div>
                </div>
            </div>
        </header>
        <article id="content" class="h-100 mt-2">
            <div class="alert alert-warning" *ngIf="isSubCity">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                {{ subcityCannotBeEditedMessage }}
            </div>
            <div class="button-container mb-3 justify-content-end" permission-display
                [module]="permission.administration.module" [functionality]="permission.administration.updateCity">
                <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small warn"
                    type="button" (click)="editForm()" *ngIf="cityForm.disabled && !isSubCity">
                    <span class="mat-button-wrapper">Editar</span>
                </button>
                <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small warn"
                    type="button" (click)="cancelEditForm()" *ngIf="cityForm.enabled">
                    <span class="mat-button-wrapper">Cancelar</span>
                </button>
                <button class="mx-2" type="button" mat-raised-button color="accent" (click)="saveCity()"
                    *ngIf="cityForm.enabled">
                    <span class="mat-button-wrapper">Guardar</span>
                </button>
            </div>
            <form class="form_container row city-form-fields" [formGroup]="cityForm">
                <div class="col-md-6">
                    <mat-form-field appearance="standard">
                        <mat-label>Ciudad<span class="asterisk" *ngIf="ifFieldMandatory('name')">*</span></mat-label>
                        <input matInput type="text" formControlName="name">
                        <mat-error *ngIf="cityForm.get('name').errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="standard">
                        <mat-label>Reteica<span class="asterisk"
                                *ngIf="ifFieldMandatory('reteica')">*</span></mat-label>
                        <input matInput type="text" onlyNumbersDouble formControlName="reteica">
                        <i matSuffix class="fas fa-info-circle color-secondary-dark cursor-pointer"
                            *ngIf="cityForm.get('reteica').enabled"
                            matTooltip="Ingrese un porcentaje entre 0% y 100% (donde 0 equivale a 0% y 1 equivale a 100%)"
                            matTooltipClass="tooltip__alert" matTooltipPosition="right"></i>
                        <mat-error *ngIf="cityForm.get('reteica').errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                        <mat-error *ngIf="cityForm.get('reteica')?.errors?.max">
                            {{ utils.giveMessageError('MAX_VALUE_EXCEED', 'reteica', "1" )}}
                        </mat-error>
                        <mat-error *ngIf="cityForm.get('reteica')?.errors?.min">
                            {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'reteica', 0) }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!--Fields for Siigo-->
                <div class="text-strong col-12 mt-0 mt-md-3" *ngIf="hasSiigoIntegration">Retefuente</div>
                <div class="col-md-6" *ngIf="hasSiigoIntegration" id="taxSiigoStep">
                    <mat-form-field appearance="standard">
                        <mat-label>Descripción<span class="asterisk"
                                *ngIf="ifFieldMandatory('taxSiigo')">*</span></mat-label>
                        <mat-select [formControl]="taxSiigoControl" [disabled]="cityForm.disabled"
                            (selectionChange)="onTaxSiigoChange($event)">
                            <mat-option *ngFor="let option of taxOptions" [value]="option" [disabled]="!option.active">
                                {{option.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="taxSiigoControl.errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                        <mat-hint>*Requerido para contabilidad y facturación</mat-hint>
                    </mat-form-field>
                </div>
                <div class="col-md-6" *ngIf="hasSiigoIntegration">
                    <mat-form-field appearance="standard">
                        <mat-label>Código<span class="asterisk"
                                *ngIf="ifFieldMandatory('taxSiigo')">*</span></mat-label>
                        <input matInput type="text"
                            [value]="taxSiigoControl?.value?.id ? taxSiigoControl?.value?.id : ''" disabled>
                    </mat-form-field>
                </div>


                <!--Fields for WorldOffice-->
                <div class="col-md-6" *ngIf="hasWorldOfficeIntegration">
                    <mat-form-field appearance="standard">
                        <mat-label>Código zonal<span class="asterisk"
                                *ngIf="ifFieldMandatory('zoneCode')">*</span></mat-label>
                        <input matInput type="text" formControlName="zoneCode">
                        <mat-error *ngIf="cityForm.get('zoneCode').errors?.required">
                            {{ utils.giveMessageError('MANDATORY_FIELD') }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Accounting section -->
                <div class="text-strong col-12 mt-0 mt-md-3">
                    <div class="text-strong">Contabilidad</div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field appearance="standard">
                                <mat-label>Cuenta débito<span class="asterisk"
                                        *ngIf="ifFieldMandatory('debitAccount')">*</span></mat-label>
                                <input matInput type="text" onlyNumbersInt formControlName="debitAccount">
                                <mat-error *ngIf="cityForm.get('debitAccount').errors?.required">
                                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field appearance="standard">
                                <mat-label>Cuenta ica (opcional)<span class="asterisk"
                                        *ngIf="ifFieldMandatory('icaAccount')">*</span></mat-label>
                                <input matInput type="text" onlyNumbersDouble formControlName="icaAccount">
                            </mat-form-field>
                        </div>
                        <div class="text-strong col-12 mt-0 mt-md-3" *ngIf="hasSiigoIntegration">Código ica</div>
                        <div class="col-md-6" *ngIf="hasSiigoIntegration">
                            <mat-form-field appearance="standard">
                                <mat-label>Descripción<span class="asterisk"
                                        *ngIf="ifFieldMandatory('icaSiigo')">*</span></mat-label>
                                <mat-select formControlName="icaSiigo" [disabled]="cityForm.disabled">
                                    <mat-option *ngFor="let option of taxOptions" [value]="option.id">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="cityForm.get('icaSiigo').errors?.required">
                                    {{ utils.giveMessageError('MANDATORY_FIELD') }}
                                </mat-error>
                                <mat-error *ngIf="cityForm.get('icaSiigo').errors?.min">
                                    {{ utils.giveMessageError('MIN_VALUE_NOT_REACHED', 'código ica', minIcaSiigo) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6" *ngIf="hasSiigoIntegration">
                            <mat-form-field appearance="standard">
                                <mat-label>Código<span class="asterisk"
                                        *ngIf="ifFieldMandatory('icaSiigo')">*</span></mat-label>
                                <input matInput type="text"
                                    [value]="cityForm.get('icaSiigo')?.value ? cityForm.get('icaSiigo')?.value : ''"
                                    disabled>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <!-- Billing section -->
                <div class="text-strong col-12 px-0 mt-0 mt-md-3 d-flex flex-wrap" *ngIf="hasSiigoIntegration"
                    id="productSiigoStep">
                    <div class="text-strong col-12">Facturación - Producto Siigo</div>
                    <div class="col-md-6">
                        <mat-form-field appearance="standard">
                            <mat-label>Descripción<span class="asterisk"
                                    *ngIf="ifFieldMandatory('productSiigo')">*</span></mat-label>
                            <mat-select #mySelect formControlName="productSiigo" [disabled]="cityForm.disabled">
                                <mat-option *ngFor="let option of siigoOptions" [value]="option.code"
                                    (click)="onProductSiigoChange(option.code)">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="cityForm.get('productSiigo').errors?.required">
                                {{ utils.giveMessageError('MANDATORY_FIELD') }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="standard">
                            <mat-label>Código<span class="asterisk"
                                    *ngIf="ifFieldMandatory('productSiigo')">*</span></mat-label>
                            <input matInput type="text"
                                [value]="cityForm.get('productSiigo')?.value ? cityForm.get('productSiigo')?.value : ''"
                                disabled>
                        </mat-form-field>
                    </div>
                </div>

            </form>
            <mat-divider *ngIf="mainCityName.value && canLinkCities"></mat-divider>
            <form class="form_container row city-form-fields" *ngIf="mainCityName.value && canLinkCities">
                <div class="col-md-6 p-0 mt-2">
                    <mat-form-field appearance="standard">
                        <mat-label>Ciudad principal<span class="asterisk"
                                *ngIf="ifFieldMandatory('mainCityName')">*</span></mat-label>
                        <input matInput type="text" [formControl]="mainCityName">
                    </mat-form-field>
                </div>
            </form>
            <!-- Subciudades: agregar y listado en la misma sección, para ver lo guardado donde se agrega. -->
            <section class="subcities-section" *ngIf="isMainCity && canLinkCities">
                <label class="subtitle-component">
                    <i class="fas fa-tree-city"></i>
                    Subciudades
                </label>

                <!-- Agregar: panel propio para no confundirlo con el filtro de las ya asociadas. -->
                <div class="subcities-add" permission-display [module]="permission.administration.module"
                    [functionality]="permission.administration.addSubCities">
                    <div class="subcities-block-title">
                        <i class="fas fa-plus-circle"></i>
                        Agregar subciudades
                    </div>
                    <p class="subcities-help">Busca una ciudad y selecciónala; puedes elegir varias y guardarlas juntas.</p>
                    <div class="row mx-0">
                        <div class="col-md-8 px-0 pr-md-3">
                            <app-autocomplete-city [inputFormControl]="subCityControl" [options]="optionsSubcity">
                            </app-autocomplete-city>
                        </div>
                        <div class="col-md-4 px-0 d-flex align-items-center justify-content-center subcities-add__action">
                            <button mat-raised-button color="primary" (click)="onSubmit()" class="button-width-auto">
                                <i class="fas fa-plus mr-2"></i>
                                Añadir Subciudades<span *ngIf="pendingSubcities.length"> ({{ pendingSubcities.length }})</span>
                            </button>
                        </div>
                        <div class="col-12 px-0 pending-subcities" *ngIf="pendingSubcities.length">
                            <span class="pending-subcities-label">Por añadir ({{ pendingSubcities.length }}):</span>
                            <mat-chip-list aria-label="Subciudades por añadir">
                                <mat-chip *ngFor="let subcity of pendingSubcities" [removable]="true"
                                    (removed)="removePendingSubcity(subcity)">
                                    {{ subcity.name }}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </mat-chip-list>
                        </div>
                    </div>
                </div>

                <!-- Asociadas: el filtro solo busca entre las ya guardadas. -->
                <div class="subcities-block-title subcities-block-title--list">
                    <i class="fas fa-list-ul"></i>
                    Asociadas ({{ subcities?.length || 0 }})
                </div>
                <ng-container *ngIf="subcities?.length; else noSubcities">
                    <div class="col-md-6">
                        <mat-form-field appearance="standard">
                            <mat-label>Filtrar subciudades asociadas</mat-label>
                            <i matPrefix class="fas fa-search subcities-filter-icon"></i>
                            <input matInput type="text" [formControl]="subCityFilterControl"
                                placeholder="Nombre de una subciudad ya asociada">
                        </mat-form-field>
                    </div>
                    <div class="d-flex flex-wrap mx-0 px-0">
                        <div class="col-lg-3 col-md-6 col-sm-12" *ngFor="let subcity of subcitiesToShow">
                            <app-subcity-item [subcity]="subcity" (delete)="deleteSubcity($event)">
                            </app-subcity-item>
                        </div>
                    </div>
                </ng-container>
                <ng-template #noSubcities>
                    <p class="subcities-empty">Esta ciudad aún no tiene subciudades asociadas.</p>
                </ng-template>
            </section>
        </article>
    </section>
</div>